import { Disclosure } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/outline';
import Image from 'next/image';
import { useRef, useState } from 'react';
import { useEffectOnce } from 'react-use';

import type { IBullet } from '../home.interface';
import type { IProps } from './FeaturesPage';

/* Feature with Expandable bullets */
export const DataTypeFeature = ({ feature }: IProps) => {
  const styles = {
    container: {
      background:
        'linear-gradient(180deg, rgba(242, 250, 255, 0) 0%, #F2FAFF 55.21%, rgba(242, 250, 255, 0) 100%)',
    },
  };

  const [clicked, setClicked] = useState(0);
  const buttonRefs = useRef<any>([]);
  const openedRef = useRef<any>(null);
  // const datatypeImage = [
  //   {
  //     imagePath: `/images/icons/datatype/datatype-${clicked + 1}/datatype_${
  //       clicked + 1
  //     }-2x.png`,
  //     imageWidth: 1024,
  //     alt:
  //       feature.bullets && feature.bullets[clicked]
  //         ? feature.bullets[clicked]!.alt
  //         : 'image',
  //   },
  // ];

  const clickRecent = (index: number) => {
    const clickedBtn = buttonRefs.current[index];
    if (clickedBtn === openedRef.current) {
      openedRef.current = null;
      return;
    }
    if (openedRef.current?.getAttribute('data-value')) {
      openedRef.current?.click();
    }
    openedRef.current = clickedBtn;
  };

  useEffectOnce(() => {
    openedRef.current = buttonRefs.current[0];
  });

  const defaultImage: string = `/images/icons/datatype/datatype-${
    clicked + 1
  }/datatype_${clicked + 1}-1x.png`;

  return (
    <div style={styles.container}>
      <div className="container mx-auto flex flex-col p-4 md:flex-row md:items-center md:justify-center md:gap-x-[10%] md:px-[10%]">
        <div className="w-full md:w-[50%] ">
          {/* <OptimisedImage
            data={datatypeImage}
            defaultImagePath={defaultImage}
          /> */}
          <Image
            src={defaultImage}
            width={1024}
            height={1024}
            alt={
              feature.bullets && feature.bullets[clicked]
                ? feature.bullets[clicked]!.alt
                : 'image'
            }
          />
        </div>

        <div className="flex flex-col md:max-w-[40%]">
          <div className="mb-3 text-xl font-medium text-[#3D3E40] md:text-2xl lg:text-4xl">
            {feature.title}
          </div>
          <div className="mb-5 py-2 text-[15px] font-normal text-[#616366]">
            {feature.description}
          </div>
          <div className="flex flex-col">
            <div className="grid grid-cols-1 divide-y">
              {feature.bullets?.map((bullet: IBullet, idx: number) => (
                /* Bullet Component START */
                <div
                  key={idx}
                  className="mx-auto w-full opacity-75 hover:bg-gray-100 focus:outline-none focus-visible:ring focus-visible:ring-sky-500"
                >
                  <Disclosure defaultOpen={idx === clicked}>
                    {({ open }) => (
                      <>
                        <Disclosure.Button
                          ref={(ref: any) => {
                            buttonRefs.current[idx] = ref;
                          }}
                          className="flex w-full justify-between py-5 text-left"
                          onClick={() => {
                            if (!open) {
                              setClicked(idx);
                            }
                            clickRecent(idx);
                          }}
                          data-value={open}
                        >
                          <span className="text-[17px] font-medium text-[#555659]">
                            {bullet.title}
                          </span>
                          <div className="h-5 w-5 shrink-0 grow-0">
                            <ChevronDownIcon
                              className={`mt-1 text-gray-900 ${
                                open ? 'rotate-180' : ''
                              }`}
                            />
                          </div>
                        </Disclosure.Button>
                        <Disclosure.Panel className="pb-4 pt-2 text-sm text-gray-700">
                          <div className="text-left text-[16px] font-normal text-[#616366]">
                            {bullet.details}
                          </div>
                        </Disclosure.Panel>
                      </>
                    )}
                  </Disclosure>
                </div>
                /* Bullet Component END */
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
